import { useEffect, useState } from "react";

// Tiny pub/sub for the offline/sync status pill.
const state = { online: typeof navigator !== "undefined" ? navigator.onLine : true, pending: 0, syncing: false, stuck: false };
const subs = new Set();

export function getState() { return { ...state }; }
export function setStatus(patch) { Object.assign(state, patch); const snap = getState(); subs.forEach((f) => f(snap)); }
export function subscribe(f) { subs.add(f); return () => subs.delete(f); }

export function useOffline() {
  const [s, setS] = useState(getState());
  useEffect(() => subscribe(setS), []);
  return s;
}
